import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dumbbell, Clock, Flame } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Workouts() {
  const [workouts, setWorkouts] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/fitness/workouts");
      setWorkouts(data);
    })();
  }, []);

  return (
    <div className="px-4 md:px-8 py-8 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mb-2">Fitness</div>
          <h1 className="font-display text-4xl">Workouts</h1>
          <p className="text-muted-foreground text-sm mt-1">{workouts.length} templates & sessions</p>
        </div>
        <Link to="/app/fitness/ai-workout">
          <Button className="rounded-full">Generate with AI</Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {workouts.map((w) => (
          <div key={w.id} className="rounded-xl border border-border bg-card p-6">
            <div className="flex items-start justify-between mb-3">
              <div>
                <div className="font-display text-2xl leading-tight">{w.title}</div>
                <div className="text-sm text-muted-foreground mt-1">{w.description}</div>
              </div>
              <Dumbbell className="h-5 w-5 text-primary" />
            </div>
            <div className="flex items-center gap-4 text-xs text-muted-foreground mb-4">
              {w.duration_min && (
                <span className="inline-flex items-center gap-1">
                  <Clock className="h-3.5 w-3.5" /> {w.duration_min} min
                </span>
              )}
              {w.difficulty && (
                <span className="inline-flex items-center gap-1">
                  <Flame className="h-3.5 w-3.5" /> {w.difficulty}
                </span>
              )}
              {w.focus && (
                <span className="uppercase tracking-widest text-[10px]">{w.focus}</span>
              )}
            </div>
            <ul className="text-sm space-y-1">
              {(w.blocks || []).slice(0, 6).map((b, i) => (
                <li key={i} className="flex items-baseline gap-3 border-b border-border/50 py-1.5 last:border-0">
                  <span className="text-muted-foreground w-5 text-xs">{i + 1}</span>
                  <span className="flex-1 truncate">{b.exercise_name}</span>
                  <span className="text-muted-foreground text-xs">{b.sets ?? ""}{b.sets ? "×" : ""}{b.reps ?? ""}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
        {workouts.length === 0 && (
          <div className="text-sm text-muted-foreground">No workouts yet — try the AI generator.</div>
        )}
      </div>
    </div>
  );
}
